import api from "./axios";

export const fetchLeads = async (
  page = 1,
  lift_type = null,
  created_by = null,
  per_page = 15,
  status = null,
  search = null,
) => {
  return api.get("/leads", {
    params: {
      page,
      lift_type,
      created_by,
      per_page,
      status,
      search,
    },
  });
};

export const fetchLeadCounts = async () => {
  return api.get("/leads/counts");
};

export const exportLeads = async (
  lift_type = null,
  created_by = null,
  status = null,
  search = null,
) => {
  return api.get("/leads", {
    params: {
      lift_type,
      created_by,
      status,
      search,
      export: true,
    },
    responseType: 'blob',
  });
};
export const fetchLeadById = async (id) => {
  return api.get(`/leads/${id}`);
};

export const updateLead = async (id, data) => {
  return api.put(`/leads/${id}`, data);
};

export const rejectLead = async (id, rejection_reason) => {
  return api.post(`/leads/${id}/reject`, { rejection_reason });
};
